import styled from "styled-components";
import { Icon } from "..";
import { theme } from "../../../styles/themes";
import Container from "../container/container";

export const ToastContainer = styled(Container).attrs(
  (props: { $success: boolean }) => ({
    elevation: "high",
    success: props.$success,
  }),
)<{ $success: boolean }>`
  background-color: ${({ success }) =>
    success
      ? theme.color.positive.background.default.default
      : theme.color.surface.background.stronger.default};
  color: ${theme.color.surface.text.inverse.default};
  padding: 12px 20px 12px 16px;
  position: fixed;
  bottom: 24px;
  right: 105px;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 19999;
`;

export const Message = styled(Container)`
  margin: 0 12px;
`;

export const SuccessIcon = styled(Icon).attrs(props => ({
  icon: "check-circle-fill",
  size: props.size ? props.size : "md",
  color: "success",
}))``;

export const ErrorIcon = styled(Icon).attrs(props => ({
  icon: "alert",
  size: props.size ? props.size : "md",
  color: "error",
}))``;
